import React from "react";
import s from "./loadingBar.scss";

export default props => {
  const pctg = props.pctg;

  let color = "#29c369";
  if (pctg > 60) color = "#fbc330";
  if (pctg > 85) color = "#e45548";

  return (
    <div className={s.loadingBar}>
      <div className={s.quota} style={{ width: `${pctg}%`, backgroundColor: color }} />
    </div>
  );
};
